import driverTransactionSummary from '@/api/report/driver-transaction-summary'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
}

export const getters = {}

export const mutations = {
  ...baseMutations
}

export const actions = {
  fetch(context, data) {
    return driverTransactionSummary.viewData(data)
  },
  toPdf(context, data) {
    return driverTransactionSummary.toPdf(data)
  }
}